import styled from "styled-components";

export const Card = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);
    border: 1px solid #D8DEEC;
    border-radius: 16px;
    opacity: 1;
    color: #000;
    width: 257px;
    display: row;
    max-width: 26.375rem;
    max-height: 130px;
    padding: 14px 20px 20px 20px;
    box-sizing: border-box;
    position: relative;
`;

export const Number = styled.div`
    font-size: 2rem;
    font-weight: 700;
    font-family: Manrope, Helvetica, sans-serif;
    margin: 0;
    text-align: left;
`;
